var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay-result"},[_c('div',{staticClass:"success-top"},[_c('img',{attrs:{"src":require("@/assets/images/pay/paySuccess.png"),"alt":""}}),_c('div',{staticClass:"text-success"},[_vm._v("支付成功")]),_c('div',{staticClass:"text-alert"},[_vm._v("请于付款后尽快离场，以免产生额外费用")])])])
}]

export { render, staticRenderFns }